import { meQuery, OrgFragment, PersonOrgFragment, PersonStatus } from './verid-api-types';
// import { Me, Org, PersonOrg } from './use-auth-service';

export type Me = Omit<meQuery['me'], '__typename'>;

export interface UserState {
  me: Me | undefined;
  isLoggedIn: boolean;
  ready: boolean;
}

export interface UserContextType {
  userState: UserState;
  setUserState: (v: UserState) => void | Promise<void>;
  $: UserContextUtils;
}
export class UserContextUtils {
  constructor(private me: Me | undefined) {}
  currentPersonOrg(): Me['personOrgs'][number] | undefined {
    let retVal: OrgFragment | undefined = undefined;
    if (this.me) {
      const currentOrgId = this.me.currentOrgId || this.getCurrentOrgId() || this.me.personOrgs[0].orgId;
      for (const personOrg of this.me.personOrgs) {
        if (personOrg.orgId === currentOrgId) {
          return personOrg;
        }
      }
    }
    return retVal;
  }

  saveCurrentOrgId(orgId: string) {
    sessionStorage.setItem('currentOrgId', orgId);
  }

  getCurrentOrgId() {
    return sessionStorage.getItem('currentOrgId');
  }

  currentOrgId(): string | undefined {
    const currentPersonOrgVar = this.currentPersonOrg();
    return currentPersonOrgVar ? currentPersonOrgVar.org.id : undefined;
  }

  isJurisdictionAdmin(): boolean {
    const index = this.getPersonOrgs().findIndex((perOrg) => perOrg.org.type === 'JURISDICTION' && perOrg.role === 'ADMIN');
    return index >= 0;
  }

  isProviderOrgAdmin(): boolean {
    const index = this.getPersonOrgs().findIndex((perOrg) => perOrg.org.type === 'PROVIDER' && perOrg.role === 'ADMIN');
    return index >= 0;
  }

  isOrgAdmin(): boolean {
    const index = this.getPersonOrgs().findIndex((perOrg) => perOrg.role === 'ADMIN');
    return index >= 0;
  }

  getOrgs(): Me['personOrgs'][number]['org'][] {
    return this.me?.personOrgs.map((personOrg) => personOrg.org) ?? [];
  }

  private getPersonOrgs(): Me['personOrgs'] {
    return this.me?.personOrgs ?? [];
  }
}

export const blankUserState: UserState = {
  me: {
    createdAt: new Date(),
    updatedAt: new Date(),
    id: '',
    isTest: false,
    status: PersonStatus.DELETED,
    personOrgs: [],
    currentOrgId: '',
    systemAccount: null,
  },
  isLoggedIn: false,
  ready: false,
};
